import type { OperationRun } from '@foodlista/trigger-vue'

export interface OperationTaskPayload<T = unknown> {
  operationId?: string
  restaurantSlug?: string
  initiatedBy?: string | null
  data?: T
}

export function operationPayloadOf<T = unknown>(
  run: OperationRun,
): OperationTaskPayload<T> | undefined {
  return run.payload as OperationTaskPayload<T> | undefined
}

export function operationIdOf(run: OperationRun): string | undefined {
  return operationPayloadOf(run)?.operationId
}
